import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';
import { useState,useEffect,useRef } from 'react';
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const stripePromise = loadStripe('pk_live_51LvUUeHGbN9IYaOkazcdvf4yO1vjXNVTM32FYYTt05vGpeMYavSkrrb9M8XHiR54OUSIStszWpXqPrI4qsVQTlMa00GuJ5Po7d');

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

export default function Achat() {
    const [clientSecret, setClientSecret] = useState("");
    const [montant, setMontant] = useState(null);
    const [isLoading,setIsloading] = useState(false);

   
    const getSecret = async () => {
        try{
            setIsloading(true);
            const form = new FormData();
            form.append("montant", document.querySelector("#montant").value);
            const response = await axiosInstance.post("api/achat", form);
            setClientSecret(response.data.client_secret);
            setIsloading(false);
        }
        catch(error)
        {
            console.log(error);
        }
        }
   
 

    const options = {
        // passing the client secret obtained from the server
        clientSecret: clientSecret,
    };
    const changeMontant = async(e) => {
        setIsloading(true);
        e.preventDefault();
        setMontant(()=>e.target.value);
        await getSecret();
        setIsloading(false);
      };
  return (
    <div style={{width:"500px",backgroundColor:"whitesmoke",color:"black"}} className="p-5 mx-auto bg-white rounded-xl sm:rounded-3xl lg:rounded-[40px] shadow-lg dark:bg-neutral-900">
        <div className='centrer'>
            <table style={{padding:"0px", width:"600px"}}>
                <tbody>
                    <tr style={{padding:"0px"}}>
                        <td style={{width:"100%"}} className="center inline-block align-middle text-2xl font-semibold md:text-3xl">Dons</td>
                    </tr>
                    <tr>
                        <td>Montant:</td>
                        <td>
                            <select name="montant" id="montant" onChange={changeMontant} >
                                <option value="0">Choisissez un montant</option>
                                <option value="1000">10$</option>
                                <option value="2500">25$</option>
                                <option value="5000">50$</option>
                                <option value="10000">100$</option>
                                <option value="20000">200$</option>
                            </select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <br></br>
    {
        (clientSecret && !isLoading) ? (
        <Elements stripe={stripePromise} options={options} >
            <CheckoutForm montant={montant} />
        </Elements>
        ):<div></div>
    }
  </div>
  )
};